import {
    FETCH_FEEDBKDETAILS_SUCCESS_ACTION,
} from './action'

const initialState = {
    processing: false,
    error: false,
  }

export default function (state: any = initialState, action: Function) {
   
    switch (action.type) {
        case FETCH_FEEDBKDETAILS_SUCCESS_ACTION:
         
            return {
                ...state,
                fedbckDtlsList: action.payload.rows,
                fedbckDtlsCount:action.payload.count
            }
        default:
            return {
                ...state
            }
    }

}